import {inject, Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize, tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {WINDOW} from '../../../../window-providers';
import {PageSignalStore} from '../../../../shared/store/page/page.signal-store';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class NotFoundInterceptor implements HttpInterceptor {
  errorCodeWhitelist: string[] = ['error.mail.recipients', 'error.mail.buyer.recipients',
    'error.mail.custodian.recipients', 'error.mail.buyerAndCustodian.recipients'];
  private readonly router = inject(Router);
  private readonly pageSignalStore = inject(PageSignalStore);
  private readonly window = inject<Window>(WINDOW);

  intercept(req: HttpRequest<any>, next: HttpHandler):
      Observable<HttpEvent<any>> {
    let ok: string;
    let errorStatus: number;
    let errorCode: string;


    // regex to match offerDetails
    const offerDetailRegex = /\/offer\/\d+$/;
    if (!window.location.pathname.match(offerDetailRegex)) {
      return next.handle(req);
    }

    return next.handle(req)
      .pipe(
        tap(
          event => ok = event instanceof HttpResponse ? 'succeeded' : '',
          error => {
            errorStatus = error.status;
            errorCode = error instanceof HttpErrorResponse ? error.error.code : 'undefinded';
            ok = 'failed';
          }
        ),
        finalize(() => {
          if (ok === 'failed' && errorStatus === 404 && !this.isWhitelistErrorCode(errorCode)) {
            this.fallbackDisableSpinner();
            this.router.navigateByUrl(`error/${errorStatus}`);
          }
        })
      );
  }

  /**
   * just in case the spinner state was set true directly without using the spinner service
   */
  fallbackDisableSpinner(): void {
    this.pageSignalStore.updateLoading(false);
  }

  /**
   * Checks if the error code of the error is on the whitelist of error Codes
   * @param error the error you want to check
   */
  isWhitelistErrorCode(error: string) {
    return this.errorCodeWhitelist.includes(error);
  }
}
